const notionCard = {
  notionTitle: "Central de Conhecimento GEEQUIP no Notion!",
  notionDescription: "Acesse o Notion e veja todos os tutoriais disponíveis para você!",
  notionLink: "Acessar Tutoriais",
}

export default notionCard;